import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { FcpCheckboxModule, FcpBadgeModule } from 'fc-ui-components';

import { ReorderBrandListComponent } from './reorder-brand-list.component';

@NgModule({
    imports: [CommonModule, TranslateModule, FcpCheckboxModule, FcpBadgeModule],
    declarations: [ReorderBrandListComponent],
    exports: [ReorderBrandListComponent]
})
export class ReorderBrandListModule {}
